import { z } from 'zod';
import { completeReportingRange } from './reporting.js';
/*
 * Sannheten — contract for GET /api/dashboard/truth.
 * Mirrors apps/api/src/truth/index.ts computeTruth().
 */
export const metricKey = z.enum([
    'bookinger',
    'moter',
    'oppmote',
    'closing',
    'vekst',
    'kansellering',
]);
export const truthRow = z.object({
    key: z.string(),
    name: z.string(),
    phone: z.string().nullable(),
    bookedAt: z.string().nullable(),
    bookedSource: z.enum(['egen', 'momence']).nullable(),
    slotAt: z.string(),
    slotTime: z.string(),
    status: z.enum(['mott', 'ikke-mott', 'venter', 'kommer', 'avbestilt', 'ikke-i-momence']),
    member: z.enum(['medlem', 'ikke', 'var-medlem']).nullable(),
    memberSince: z.string().nullable(),
    source: z.enum(['egen', 'momence']),
    countsIn: z.array(metricKey),
});
export const truthMetricBlock = z.object({
    value: z.number().nullable(),
    numerator: z.number().optional(),
    denominator: z.number().optional(),
    perDay: z.number().optional(),
    prevValue: z.number().nullable(),
    immature: z.number().optional(),
});
export const truthResponse = z.object({
    ok: z.literal(true),
    from: z.string(),
    to: z.string(),
    prevFrom: z.string(),
    prevTo: z.string(),
    range: completeReportingRange,
    scannedAt: z.string().nullable(),
    truthRefresh: z.object({
        lastSuccessfulAt: z.string().nullable(),
        latestRun: z
            .object({
            status: z.string(),
            startedAt: z.string(),
            finishedAt: z.string().nullable(),
            itemsProcessed: z.number().int().nonnegative(),
            itemsFailed: z.number().int().nonnegative(),
        })
            .nullable(),
    }),
    goalBookingsPerDay: z.number(),
    momenceBookings: z.number(),
    moterEgenKalender: z.number(),
    moterOppfolging: z.number(),
    spend: truthMetricBlock,
    bookingerInn: truthMetricBlock,
    moter: truthMetricBlock,
    kostPerMote: truthMetricBlock,
    oppmote: truthMetricBlock,
    closing: truthMetricBlock,
    vekst: truthMetricBlock.extend({
        availability: z.literal('unavailable'),
        reasonCode: z.literal('use_growth_member_events'),
        aktiveNa: z.number(),
        frosne: z.number(),
        nye: z.null(),
        tapte: z.null(),
        netto: z.null(),
        utenProvetime: z.null(),
    }),
    kansellering: truthMetricBlock,
    people: z.array(truthRow),
});
export const truthRefreshResponse = z.object({
    ok: z.literal(true),
    members: z.number(),
    appointments: z.number(),
});
//# sourceMappingURL=truth.js.map